import request from '@/utils/request'

// 查询收藏信息
export function queryList(query) {
  return request({
    url: '/web/collect/list',
    method: 'get',
    params: query
  })
}

//新增收藏
export function addCollect(data) {
  return request({
    url: '/web/collect',
      method: 'post',
      data: data
  })
}

//取消收藏
export function deleteCollect(recid) {
    return request({
        url: '/web/collect/remove/' + recid,

        method: 'post',
    })
}

